(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dolceamore-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var tsField = document.getElementById('dak_ct_ts');
  if (tsField) tsField.value = String(Date.now());

  var form = document.querySelector('.dak-ct__form-card form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    var hp = document.getElementById('dak_ct_hp');
    if (hp && hp.value !== '') {
      e.preventDefault();
      return;
    }

    var ts = document.getElementById('dak_ct_ts');
    if (ts && ts.value) {
      var elapsed = Date.now() - parseInt(ts.value, 10);
      if (elapsed < 3000) {
        e.preventDefault();
        return;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolceamore-main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ── Gallery thumbnail switcher ──────────────────────────────
  document.querySelectorAll('.dak-mp__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.dataset.target;
      var mainImg  = document.getElementById(targetId);
      if (mainImg) {
        mainImg.src    = btn.dataset.src;
        mainImg.srcset = btn.dataset.srcset || '';
      }
      var gallery = btn.closest('.dak-mp__thumbnails');
      if (gallery) gallery.querySelectorAll('.dak-mp__thumb').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // ── Accordion ───────────────────────────────────────────────
  document.querySelectorAll('.dak-mp__acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.dak-mp__acc-item');
      var body   = item.querySelector('.dak-mp__acc-body');
      var isOpen = body.classList.contains('open');
      body.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', !isOpen);
      item.classList.toggle('is-open', !isOpen);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
